import { useTranslation } from 'react-i18next'
import { CONTRACT_TYPE_BADGE_CLASS } from '../../../utils/workforceUtils'

const ContractBadge = ({ contract }) => {
    if (!contract) return <span className="text-gray-400">—</span>
    const cls = CONTRACT_TYPE_BADGE_CLASS[contract] || CONTRACT_TYPE_BADGE_CLASS.CUBBO
    return <span className={`inline-flex px-2 py-0.5 text-xs rounded-full border ${cls}`}>{contract}</span>
}

const PeriodBadge = ({ period, t }) => {
    if (!period) return <span className="text-gray-400">—</span>
    const cls = period === 'night'
        ? 'bg-indigo-50 text-indigo-700 border-indigo-200'
        : 'bg-yellow-50 text-yellow-800 border-yellow-200'
    return <span className={`inline-flex px-2 py-0.5 text-xs rounded-full border ${cls}`}>{t(`workforce.shifts.period_${period}`)}</span>
}

export const AttendanceBreakdownTable = ({ rows }) => {
    const { t } = useTranslation()

    if (!rows || rows.length === 0) {
        return (
            <div className="p-6 text-center text-gray-500 border rounded bg-white">
                {t('workforce.analytics.breakdown_empty')}
            </div>
        )
    }

    return (
        <div className="bg-white border rounded-lg overflow-hidden">
            <table className="min-w-full divide-y divide-gray-200">
                <thead className="bg-gray-50">
                    <tr>
                        <th className="px-4 py-2 text-left text-xs font-medium text-gray-500 uppercase">{t('workforce.analytics.contract')}</th>
                        <th className="px-4 py-2 text-left text-xs font-medium text-gray-500 uppercase">{t('workforce.analytics.shift_period')}</th>
                        <th className="px-4 py-2 text-left text-xs font-medium text-gray-500 uppercase">{t('workforce.analytics.operator_types')}</th>
                        <th className="px-4 py-2 text-left text-xs font-medium text-gray-500 uppercase">{t('workforce.analytics.row_type')}</th>
                        <th className="px-4 py-2 text-right text-xs font-medium text-gray-500 uppercase">{t('workforce.analytics.present_days')}</th>
                        <th className="px-4 py-2 text-right text-xs font-medium text-gray-500 uppercase">{t('workforce.analytics.extra_ops')}</th>
                        <th className="px-4 py-2 text-right text-xs font-medium text-gray-500 uppercase">{t('workforce.analytics.extra_hours')}</th>
                    </tr>
                </thead>
                <tbody className="divide-y divide-gray-200">
                    {rows.map((r, i) => {
                        const isExtra = r.row_type === 'extra'
                        return (
                            <tr key={i}>
                                <td className="px-4 py-2 text-sm"><ContractBadge contract={r.contract_type} /></td>
                                <td className="px-4 py-2 text-sm"><PeriodBadge period={r.shift_period} t={t} /></td>
                                <td className="px-4 py-2 text-sm text-gray-700">
                                    {r.operator_types && r.operator_types.length > 0
                                        ? r.operator_types.join(', ')
                                        : <span className="text-gray-400">—</span>}
                                </td>
                                <td className="px-4 py-2 text-sm">
                                    {isExtra
                                        ? <span className="inline-flex px-2 py-0.5 text-xs rounded-full bg-orange-50 text-orange-700 border border-orange-200">{t('workforce.analytics.extra')}</span>
                                        : <span className="text-gray-700">{t('workforce.analytics.primary')}</span>}
                                </td>
                                <td className="px-4 py-2 text-sm text-right font-mono tabular-nums">{isExtra ? '—' : r.present.toLocaleString()}</td>
                                <td className="px-4 py-2 text-sm text-right font-mono tabular-nums">{isExtra ? r.operator_count.toLocaleString() : '—'}</td>
                                <td className="px-4 py-2 text-sm text-right font-mono tabular-nums">{isExtra ? r.extra_hours.toLocaleString(undefined, { maximumFractionDigits: 1 }) : '—'}</td>
                            </tr>
                        )
                    })}
                </tbody>
            </table>
        </div>
    )
}
